import { ShieldAlert, X } from 'lucide-react'
import { useAdminImpersonation } from '@/contexts/AdminImpersonationContext'

/**
 * Banner fixo exibido no topo quando o Super Admin está visualizando o sistema
 * como uma empresa específica via "Entrar como empresa".
 */
export default function ImpersonationBanner() {
  const { viewingCompanyId, viewingCompanyName, isPlatformAdmin, exitImpersonation } = useAdminImpersonation()

  if (!isPlatformAdmin || !viewingCompanyId) return null

  return (
    <div
      className="sticky top-0 z-50 flex flex-wrap items-center justify-between gap-2 border-b px-4 py-2 text-xs font-semibold"
      style={{
        background: 'hsl(var(--amber) / 0.15)',
        borderColor: 'hsl(var(--amber) / 0.4)',
        color: 'hsl(var(--amber))',
      }}
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center gap-2 min-w-0">
        <ShieldAlert size={14} className="flex-shrink-0" />
        <span className="truncate">
          Você está visualizando a empresa <strong>{viewingCompanyName || '—'}</strong> como Super Admin
        </span>
      </div>
      <button
        type="button"
        onClick={exitImpersonation}
        className="flex items-center gap-1.5 rounded-md px-3 py-1 text-[11px] font-bold transition-colors"
        style={{
          background: 'hsl(var(--amber))',
          color: 'hsl(var(--bg0))',
        }}
      >
        <X size={12} />
        Sair da visualização da empresa
      </button>
    </div>
  )
}
